import type * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'

import type * as models from '../../models'

/** Converts the GraphQL user fragment to the sibling-user model. */
export function transformUserInfo(
  info: graphql.schema.FragmentMeSiblingUserFragment | null | undefined,
): models.User {
  TypeAsserter.assertIsNotNullish(info)

  return {
    id: info.id,
    name:
      info.firstName && info.lastName
        ? `${info.firstName} ${info.lastName}`
        : (info.firstName ?? info.lastName ?? undefined),
  }
}
